import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {DjPsycho} from "../../DjPsycho";
import {TimelineLite} from "gsap";
import {DjPsychoGameMode} from "../../server/DjPsychoGameMode";
import {DjPsychoSound} from "../../sound/DjPsychoSound";

export class DjPsychoIntroView extends PIXI.Container implements StageLayer {

    private _button: ContinueButton;
    private _clickCallback: any;
    private _item: PIXI.spine.Spine;
    private _startTl: TimelineLite;

    constructor() {
        super();
        this.name = "DjPsychoIntroView";

        this.init();
    }

    public onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom: number = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }
    }

    public showIntro(callback: Function): void {
        const tl: TimelineLite = new TimelineLite({
                delay: 0.2
            }),
            isFS: boolean = (DjPsycho.model.gameData.nextMode === DjPsychoGameMode.FREESPIN || DjPsycho.model.gameData.nextMode === DjPsychoGameMode.FREESPIN_AVALANCHE),
            animName: string = (isFS ? "FS_Intro" : "FSS_Intro");

        tl.add([
            () => {
                DjPsycho.xBetView.removeButton(false);
                DjPsycho.popUpView.hidePopUp();
                this._item.alpha = 1;
                this._item.visible = true;
                DjPsycho.blackBgView.showBlackBg();

                this._clickCallback = callback;
                this._button.alpha = 0;
                this._button.visible = true;

                // #159
                DjPsycho.soundPlayer.playSound(isFS ? DjPsychoSound.FS_INTRO_START : DjPsychoSound.SFS_INTRO_START);
                DjPsycho.soundPlayer.fadeMusic({
                    name: "",
                    duration: 50,
                    to: 0
                });

                // #172
                if (!DjPsycho.anyBonusBought) {
                    DjPsycho.soundPlayer.playSound(DjPsychoSound.SCRATCH);
                }
            },
            DjPsycho.createTimelineForAnimation(this._item, 0, animName, false)
        ], 0);
        tl.to(this._button, {
            duration: 0.2,
            alpha: 1
        }, 0);
        tl.add(() => {
            this._button.enable(true);
        }, 0.2);

        tl.add(() => {
            this._item.autoUpdate = true;
            this._item.state.setAnimation(0, animName + "_Idle", true);
        });

        // #159
        if (isFS) {
            tl.add(() => {
                // #50
                DjPsycho.soundPlayer.switchMusic(DjPsychoSound.FS_INTRO_MUSIC);
            }, 3.022);
        } else {
            tl.add(() => {
                // #50
                DjPsycho.soundPlayer.switchMusic(DjPsychoSound.SFS_INTRO_MUSIC);
            }, 2.984);
        }

        // #166
        this._startTl = tl;
    }

    private init(): void {
        this._item = new PIXI.spine.Spine(DjPsycho.assetLoader.getSpineAsset("fsIntro"));
        this._item.position.set(360);
        this._item.visible = false;

        this._button = new ContinueButton();
        this._button.addClickCallback(() => {
            this.onButtonClick();
        });
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.enable(false)
        this._button.visible = false;
        this.onResize();

        this.addChild(this._item, this._button);
    }

    private onButtonClick(): void {
        const tl: TimelineLite = new TimelineLite(),
            nextMode: string = DjPsycho.model.gameData.nextMode,
            isNextFS: boolean = (nextMode === DjPsychoGameMode.FREESPIN || nextMode === DjPsychoGameMode.FREESPIN_AVALANCHE);

        // #166
        if (this._startTl) {
            this._startTl.totalProgress(1);
        }

        tl.add(() => {
            DjPsycho.miniCollectors.deActivateFSTexts();
            DjPsycho.miniCollectors.toggleFSDisabled(false);
            if (isNextFS) {
                DjPsycho.miniCollectors.switchToSFSDisabled(true);
            } else {
                DjPsycho.miniCollectors.switchToSFSEnabled();
            }
            DjPsycho.backgroundElements.setMode();
            DjPsycho.keypadPlugin.setZeroBetSpinCounter(DjPsycho.model.gameData.freespinsLeft);
            DjPsycho.blackBgView.onComplete();
            this._button.enable(false);

            // #159
            DjPsycho.soundPlayer.playSound(isNextFS ? DjPsychoSound.FS_START : DjPsychoSound.SFS_START);
            DjPsycho.soundPlayer.stopSound(DjPsychoSound.FS_INTRO_START);
            DjPsycho.soundPlayer.stopSound(DjPsychoSound.FS_INTRO_MUSIC);
            DjPsycho.soundPlayer.stopSound(DjPsychoSound.SFS_INTRO_START);
            DjPsycho.soundPlayer.stopSound(DjPsychoSound.SFS_INTRO_MUSIC);
        }, 0);
        tl.to([this._button, this._item], {
            duration: 0.4,
            alpha: 0
        }, 0);

        tl.add(() => {
            this?._clickCallback();
            delete this._clickCallback;

            this._button.visible = false;
            this.resetSpine(this._item);
        });

        // #159
        tl.add(() => {
            // #50
            DjPsycho.soundPlayer.switchMusic(nextMode);
        }, (isNextFS ? 0.984 : 0.957));
    }

    private resetSpine(currSpine: PIXI.spine.Spine): void {
        currSpine.skeleton.setToSetupPose();
        currSpine.state.clearTracks();
        currSpine.visible = false;
    }
}